(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inkypanel-editor-demo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('inkypanel-playground')) {
    customElements.define('inkypanel-playground', class InkypanelPlayground extends HTMLElement {
      connectedCallback() {
        this.frame = this.querySelector('[data-playground-frame]');
        this.status = this.querySelector('[data-playground-status]');
        if (!this.frame || this.bound) return;
        this.bound = true;
        this.lastHeight = null;
        try { this.playgroundOrigin = new URL(this.frame.src).origin; }
        catch (error) { this.showFallback('The interactive demo URL is invalid.'); return; }
        this.onMessage = this.handleMessage.bind(this);
        window.addEventListener('message', this.onMessage);
        this.classList.add('is-loading');
        this.setAttribute('aria-busy', 'true');
        this.timer = window.setTimeout(() => { if (!this.classList.contains('is-ready')) this.showFallback('The interactive demo is temporarily unavailable. Open the full editor to continue.'); }, 12000);
      }
      disconnectedCallback() { window.removeEventListener('message', this.onMessage); window.clearTimeout(this.timer); this.bound = false; }
      clampHeight(value) { const minimum = Number(this.dataset.minHeight) || 620; const maximum = Number(this.dataset.maxHeight) || 1800; return Math.max(minimum, Math.min(maximum, Math.round(value))); }
      handleMessage(event) {
        if (event.origin !== this.playgroundOrigin) return;
        if (event.source !== this.frame.contentWindow) return;
        if (!event.data || (event.data.type !== 'inkypanel:ready' && event.data.type !== 'inkypanel:resize')) return;
        if (Number.isFinite(event.data.height)) {
          const height = this.clampHeight(event.data.height);
          if (height !== this.lastHeight) { this.lastHeight = height; this.frame.style.height = `${height}px`; }
        } else if (event.data.type === 'inkypanel:resize') { return; }
        this.classList.remove('is-loading', 'is-unavailable'); this.classList.add('is-ready'); this.setAttribute('aria-busy', 'false');
        if (this.status) this.status.textContent = 'Interactive InkyPanel editor ready.';
        window.clearTimeout(this.timer);
      }
      showFallback(message) { this.classList.remove('is-loading', 'is-ready'); this.classList.add('is-unavailable'); this.setAttribute('aria-busy', 'false'); if (this.status) this.status.textContent = message; }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
